
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/graduate/[applicantId]",
      function () {
        return require("private-next-pages/v2/graduate/[applicantId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/graduate/[applicantId]"])
      });
    }
  